<template>
  <UiToolbar
    v-sticky
    data-sticky-target=".ui-toolbar"
    data-sticky-class="ui-toolbar--shadowed"
    data-sticky-top-offset="0"
    :title="$t(pageTitle)"
    show-nav-icon
    @navIconClicked="handleSidebarToggle"
  >
    <div slot="actions" class="profile show-for-large">
      <NotificationsArea :label="$t('NOTIFICATIONS_AREA.TITLE')" />
      <div class="ui-toolbar__links">
        <ElDropdown
          ref="profile"
          trigger="click"
          :hide-on-click="false"
          class="chip ui-toolbar__link text-latin"
        >
          <div class="el-dropdown-link">
            <i class="el-icon-user-solid" />
            {{ $auth.user.email }}
            <i class="el-icon-arrow-down el-icon--right" />
          </div>
          <!-- TODO: should be refactored -->
          <ElDropdownMenu slot="dropdown" :style="{ width: profileWidth }">
            <ElDropdownItem>
              <RouterLink
                :to="{ name: 'logout' }"
                class="chip__menu-link profile__logout-link"
              >
                {{ $t('LOGOUT') }}
              </RouterLink>
            </ElDropdownItem>
          </ElDropdownMenu>
        </ElDropdown>
      </div>
      <LocaleDropdown class="profile__locale" />
    </div>

    <div class="profile hide-for-large">
      <NotificationsArea />
      <ElDropdown
        :hide-on-click="false"
        class="ui-toolbar__link chip text-latin "
      >
        <div class="el-dropdown-link">
          <i class="el-icon-user-solid" />
          <i class="el-icon-arrow-down el-icon--right" />
        </div>
        <ElDropdownMenu slot="dropdown">
          <ElDropdownItem>
            <RouterLink
              :to="{ name: 'logout' }"
              class="chip__menu-link profile__logout-link"
            >
              {{ $t('LOGOUT') }}
            </RouterLink>
          </ElDropdownItem>
        </ElDropdownMenu>
      </ElDropdown>
      <LocaleDropdown class="profile__locale profile__locale--for-small" />
    </div>

    <div slot="nav-icon">
      <i class="ui-icon material-icons menu">
        menu
      </i>
    </div>
  </UiToolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import UiToolbar from '@@/layout/UiToolbar';
import LocaleDropdown from '@@/common/LocaleDropdown';
import NotificationsArea from './NotificationsArea';
import sticky from '@/directives/sticky';
import { isLargeAndUp } from '@/utils/layout';
import {
  PAGETITLE,
  SIDENAV_VISIBILITY,
  SIDENAV_TOGGLE_COLLAPSED,
} from '@/store/types';

export default {
  name: 'Toolbar',
  directives: {
    sticky,
  },
  components: {
    UiToolbar,
    LocaleDropdown,
    NotificationsArea,
  },

  data() {
    return {
      profileWidth: 0,
    };
  },

  computed: {
    ...mapGetters({
      pageTitle: PAGETITLE,
      isSidebarOpen: SIDENAV_VISIBILITY,
    }),
  },
  mounted() {
    const {
      profile: { $el: profileMenu },
    } = this.$refs;
    const { width } = profileMenu.getBoundingClientRect();
    this.profileWidth = `${width}px`;
  },
  methods: {
    ...mapActions({
      toggleSidebar: SIDENAV_TOGGLE_COLLAPSED,
      changeMobileSidebarVisibility: SIDENAV_VISIBILITY,
    }),
    handleSidebarToggle() {
      if (isLargeAndUp()) {
        this.toggleSidebar();
      } else {
        this.changeMobileSidebarVisibility(!this.isSidebarOpen);
      }
    },
  },
};
</script>

<style lang="scss">
.el-icon-user-solid {
  font-size: 1.4rem;
  vertical-align: middle !important;
}

.profile {
  display: flex;
  align-items: center;
  font-size: $lb-side-nav-font-size;

  &__locale {
    &--for-small {
      margin-left: $global-margin;
      @include rtl() {
        margin-left: 0;
        margin-right: $global-margin;
      }
    }
  }

  &__link {
    color: #fff;
    margin-left: $global-margin;
    margin-right: 0;

    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin;
    }

    &:active,
    &:hover {
      color: #fff;
    }

    &--latin {
      text-transform: capitalize;
    }
  }

  &__logout-link {
    display: block;
  }
}
</style>
